export default __webpack_public_path__ + "images/EK.5cdc3f3.png";